import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285e8a1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-listing-sidebar" }
const _hoisted_2 = { class: "organization-listing-sidebar__search" }

import OrganizationListing from '@/widgets/WOrganizationSidebar/components/OrganizationListing.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { OrganizationListingType, OrganizationType } from '@/shared/types'
import { useRoute } from 'vue-router'
import { organizationsApi, usersApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { useOrganizationListing, useUser } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const { user } = useUser()

const { isOrganizationListingUpdated, updateOrganizationListing } =
  useOrganizationListing()

const loading = ref(false)
const searchingData = ref('')
const ELEMENTS_PER_PAGE = 50
let pageNumber = 0
let lastCountOrganizations = ELEMENTS_PER_PAGE

const organizations = ref<OrganizationListingType>({
  usersCount: 0,
  organizations: [],
})

const isSettings = computed(() => route.name === 'SettingsPage')
const isArchiveMode = computed(() => route.query.mode === 'archive')

watch(
  () => isOrganizationListingUpdated.value,
  (isUpdated) => {
    if (isUpdated) {
      getOrganizations()
      updateOrganizationListing(false)
    }
  }
)

watch(
  () => isArchiveMode.value,
  () => {
    getOrganizations()
  }
)

const organizationUniqueList = new Set()

const handleInputSearch = (): void => {
  pageNumber = 0
  lastCountOrganizations = 50
  organizations.value.organizations = []
  organizationUniqueList.clear()

  getOrganizations(true)
}

const loadNextPage = async () => {
  if (!pageNumber) {
    return
  }

  await getOrganizations()
}

const getOrganizations = async (isSearching = false): Promise<void> => {
  if (!user.value) {
    return
  }

  if (user.value.role === 'doktor') {
    return
  }

  const ELEMENTS_PER_PAGE = 50
  const offset = pageNumber * ELEMENTS_PER_PAGE

  if (lastCountOrganizations < ELEMENTS_PER_PAGE) {
    return
  }

  loading.value = true

  const [error, response] = await organizationsApi.getOrganizations(
    searchingData.value,
    ELEMENTS_PER_PAGE,
    isArchiveMode.value,
    offset
  )

  if (error) {
    showErrorMessage(error)
  } else {
    const responseOrganizations = response.data.organizations
    lastCountOrganizations = responseOrganizations.length
    pageNumber++

    if (isSearching) {
      organizations.value.organizations = responseOrganizations
    } else {
      const uniqueOrganizations = updateOrganizations(responseOrganizations)

      organizations.value.organizations = [
        ...organizations.value.organizations,
        ...uniqueOrganizations,
      ]
    }
  }

  loading.value = false
}

const updateOrganizations = (
  responseOrganizations: OrganizationType[]
): OrganizationType[] => {
  const updatedOrganizations: OrganizationType[] = []

  for (const organization of responseOrganizations) {
    if (!organizationUniqueList.has(organization.id)) {
      organizationUniqueList.add(organization.id)
      updatedOrganizations.push(organization)
    }
  }

  return updatedOrganizations
}

const getUsersCount = async (): Promise<void> => {
  const [error, response] = await usersApi.getUsersCount()

  if (error) {
    showErrorMessage(error)
  } else {
    organizations.value.usersCount = response.data.count
  }
}

onMounted((): void => {
  getOrganizations()
  getUsersCount()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isSettings))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_input, {
              modelValue: searchingData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchingData).value = $event)),
              clearable: "",
              placeholder: "Название, город, номер",
              size: "small",
              onInput: handleInputSearch
            }, null, 8, ["modelValue"])
          ]),
          _withDirectives(_createVNode(OrganizationListing, {
            organizations: organizations.value,
            class: "organization-listing-sidebar__listing"
          }, null, 8, ["organizations"]), [
            [_directive_infinite_scroll, loadNextPage],
            [_directive_loading, loading.value]
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})